export default __webpack_public_path__ + "static/media/YOOZ-STORIES-BANNER.6927a13c.png";